import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function HeroCollections() {
  const [title, setTitle] = useState("Artwork");
  const location = useLocation();
  
  useEffect(() => {
    if (location.state === "user") {
      setTitle("User");
    }
  }, []);

  return (
    <div>
      <div>
        <div className="hero__collections">
          <div className="container">
            <h1 className="text-center">{title} collections</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroCollections;
